/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `HAND_PICKED` - Hand Picked
* `MECHANICAL` - Mechanical
 */
export type MaterialCreationProcess = typeof MaterialCreationProcess[keyof typeof MaterialCreationProcess];


export const MaterialCreationProcess = {
  HAND_PICKED: 'HAND_PICKED',
  MECHANICAL: 'MECHANICAL',
} as const;
